export const GET_MODULES_STRUCTURE_REQUEST = 'GET_MODULES_STRUCTURE_REQUEST';
export const GET_MODULES_STRUCTURE_REQUEST_SUCCESS = 'GET_MODULES_STRUCTURE_REQUEST_SUCCESS';
export const GET_MODULES_STRUCTURE_REQUEST_FAILURE = 'GET_MODULES_STRUCTURE_REQUEST_FAILURE';
export const FILTER_GROUP_MODULES = 'FILTER_GROUP_MODULES';
export const FILTER_GROUP_MODULES_WITHOUT_OPTIONS = 'FILTER_GROUP_MODULES_WITHOUT_OPTIONS';
export const SET_MODULE_OPTION = 'SET_MODULE_OPTION';

export const SET_ALL_FIELDS_PERMISSIONS_REQUEST = 'SET_ALL_FIELDS_PERMISSIONS_REQUEST';
export const SET_ALL_FIELDS_PERMISSIONS_REQUEST_SUCCESS = 'SET_ALL_FIELDS_PERMISSIONS_REQUEST_SUCCESS';
export const SET_ALL_FIELDS_PERMISSIONS_REQUEST_FAILURE = 'SET_ALL_FIELDS_PERMISSIONS_REQUEST_FAILURE';

export const GET_MODEL_STRUCTURE_REQUEST = 'GET_MODEL_STRUCTURE_REQUEST';
export const GET_MODEL_STRUCTURE_REQUEST_SUCCESS = 'GET_MODEL_STRUCTURE_REQUEST_SUCCESS';
export const GET_MODEL_STRUCTURE_REQUEST_FAILURE = 'GET_MODEL_STRUCTURE_REQUEST_FAILURE';

export const GET_GROUP_OPTIONS_PERMISSIONS_REQUEST = 'GET_GROUP_OPTIONS_PERMISSIONS_REQUEST';
export const GET_GROUP_OPTIONS_PERMISSIONS_SUCCESS = 'GET_GROUP_OPTIONS_PERMISSIONS_SUCCESS';
export const GET_GROUP_OPTIONS_PERMISSIONS_FAILURE = 'GET_GROUP_OPTIONS_PERMISSIONS_FAILURE';

export const GET_GROUP_MODEL_FIELD_PERMISSIONS_REQUEST = 'GET_GROUP_MODEL_FIELD_PERMISSIONS_REQUEST';



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_group_update/redux/constants/get_group_data.constants.js